import { Box, Card, IconButton, Stack, Typography, useTheme } from "@mui/material"
import { User } from "iconsax-react"
import { FC } from "react"

interface UserInformationProps {
  user: {
    firstName: string
    lastName: string
    nationalCode: string
    mobileNumber: string
    birthDate: string
  }
}

const UserInformation: FC<UserInformationProps> = ({ user }) => {
  const theme = useTheme()
  const { firstName, lastName, mobileNumber } = user || {}
  return (
    <Card variant='outlined' sx={{ p: 2 }}>
      <Box display='flex' alignItems='center' gap={2}>
        <IconButton
          sx={{
            boxShadow: 3,
            fontSize: 16,
            fontWeight: 600,
            p: 1,
            color: theme.palette.text.primary,
            borderRadius: 2,
            backgroundColor: theme.palette.grey[200],
            width: "100",
            height: "100",
            "&:hover": {
              backgroundColor: theme.palette.grey[400]
            }
          }}
        >
          <User size={22} />
        </IconButton>
        <Stack spacing={1}>
          <Typography variant='subtitle1'>{`${firstName || ""} ${lastName || ""}`}</Typography>
          <Typography variant='caption' color='grey.800'>
            {mobileNumber}
          </Typography>
        </Stack>
      </Box>
    </Card>
  )
}

export default UserInformation
